var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.383,
    height: 9.383,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.691 0a4.691 4.691 0 104.692 4.691A4.7 4.7 0 004.691 0zm1.865 4.856L3.82 6.615a.2.2 0 01-.3-.164V2.932a.2.2 0 01.3-.164l2.736 1.759a.2.2 0 010 .329z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyPlay);
export default __webpack_public_path__ + "static/media/reply-play.47d00325.svg";
export { ForwardRef as ReactComponent };